export default "__VITE_ASSET__CejQAJgw__"